// eslint-disable-next-line import/prefer-default-export
export const CELL_IDENTITY_ATTRIBUTE = 'data-table-cell-identity';
